import {
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  CLEAR_ROLES_ERROR,
} from "../actions/roleActionTypes";

const initialState = {
  roles: [], //Array to store the roles fetched from the API
  isLoading: false, //Loading state for fetching roles
  addRoleError: null, //Error state for adding a role
  fetchRolesError: null, //Error state for fetching roles
  updateRoleError: null, //Error state for updating a role
  deleteRoleError: null, //Error state for deleting a role
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ROLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        addRoleError: null,
      };

    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        roles: [...state.roles, action.payload],
        isLoading: false,
        addRoleError: null,
      };

    case ADD_ROLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        addRoleError: action.payload,
      };

    case FETCH_ROLES_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchRolesError: null, //Reset errors on request
      };

    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload, //Store the roles data
        isLoading: false, //Stop loading
        fetchRolesError: null, //Clear any previous roles error
      };

    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        isLoading: false, //Stop loading
        fetchRolesError: action.payload, //Store the error message
      };

    case UPDATE_ROLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        updateRoleError: null,
      };

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role.id === action.payload.id ? action.payload : role,
        ),
        isLoading: false,
        updateRoleError: null,
      };

    case UPDATE_ROLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        updateRoleError: action.payload,
      };

    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        isLoading: true,
        deleteRoleError: null,
      };

    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.filter((role) => role.id !== action.payload),
        isLoading: false,
        deleteRoleError: null,
      };

    case DELETE_ROLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        deleteRoleError: action.payload,
      };

    case CLEAR_ROLES_ERROR:
      return {
        ...state,
        fetchRolesError: null, //Clear any existing errors
      };
    default:
      return state;
  }
};

export default roleReducer;
